import { compose } from 'redux';
import { connect } from 'react-redux';
import DialogDetailLiveStreamOrganizer from '../../pages/LiveStreamOrganizer/DialogDetailLiveStreamOrganizer';
import { ClearGetDetailLiveStreamEvent, GetDetailLiveStreamEventRequested } from '../../actions/LiveStreamManagement';

const mapStateToProps = (state) => ({
    isLoading: state.livestream.getListLiveStream.isFetching,
    detailEvent: state.livestream.getDetailLiveStream.data,
    eventInfo: state.registration.registrationViewer.data,
});

const mapDispatchToProps = (dispatch) => ({
    fetchGetDetailLiveStream: (event_name, live_stream_id) => {
        dispatch(GetDetailLiveStreamEventRequested(event_name, live_stream_id));
    },
    fetchClearDetailLiveStream: () => {
        dispatch(ClearGetDetailLiveStreamEvent());
    },
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(DialogDetailLiveStreamOrganizer);
